<template>
  <div class="print-pay-fee-container">
    <div class="receipt-page">
      <div v-for="copyIndex in 2" :key="copyIndex" class="receipt-copy">
    <div class="text-center">
      <div class="receipt-title">{{printPayFeeInfo.communityName}}
        <span v-if="printPayFeeInfo.apply === 'Y'">{{ $t('printPayFee.apply') }}</span>
        <span v-if="printPayFeeInfo.apply === 'N'">{{ $t('printPayFee.receipt') }}</span>
        <span v-if="printPayFeeInfo.apply === 'R'">{{ $t('printPayFee.refund') }}</span>
      </div>
    </div>
    <div class="receipt-info-row receipt-table-align">
      <div class="receipt-owner">{{ $t('printPayFee.owner') }}：{{printPayFeeInfo.payObjName}}</div>
      <div class="receipt-invoice-tip">凭此收据兑换发票</div>
      <div class="float-right text-right">
        <span>{{ $t('printPayFee.receiptNum') }}{{printPayFeeInfo.receiptNum}}</span>
        <br />
        <span>{{ $t('printPayFee.payTime') }}：{{printPayFeeInfo.feeTime}}</span>
      </div>
    </div>
    
    <table class="table vc-table-border receipt-table">
      <thead>
        <tr>
          <th class="text-center col-index">{{ $t('printPayFee.serialNumber') }}</th>
          <th class="text-center col-fee-name">{{ $t('printPayFee.feeItem') }}</th>
          <th class="text-center col-obj-name">{{ $t('printPayFee.houseCar') }}</th>
          <th class="text-center col-fee-range">{{ $t('printPayFee.feeRange') }}</th>
          <th class="text-center col-unit-price">{{ $t('printPayFee.unitPrice') }}</th>
          <th class="text-center col-area">{{ $t('printPayFee.areaUsage') }}</th>
          <th class="text-center col-pay-method">{{ $t('printPayFee.paymentMethod') }}</th>
          <th class="text-center col-amount">{{ $t('printPayFee.receivableActual') }}</th>
          <th class="text-center col-discount">{{ $t('printPayFee.discountAmount') }}</th>
          <th class="text-center col-remark">{{ $t('printPayFee.remark') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item,index) in printPayFeeInfo.fees" :key="index" class="vc-table-border">
          <th scope="row" class="text-center">{{index +1}}</th>
          <td class="text-center">{{item.feeName}}</td>
          <td class="text-center">{{item.objName}}</td>
          <td class="text-center">
            <div v-if="item.preDegrees">
              {{dateFormat(item.startTime)}}
              <span>{{ $t('printPayFee.to') }}</span>
              {{dateFormat(item.endTime)}}<br />
              {{item.preDegrees}} {{ $t('printPayFee.to') }} {{item.curDegrees}}
            </div>
            <div v-else-if="item.feeTypeCd === '888800010006'">
              {{ $t('printPayFee.none') }}
            </div>
            <div v-else>
              {{dateFormat(item.startTime)}}{{$t('printPayFee.to')}}{{dateFormat(item.endTime)}}
            </div>
          </td>
          <td class="text-center">{{item.squarePrice}}<br />{{item.units}}</td>
          <td class="text-center">{{item.area}}</td>
          <td class="text-center">{{item.primeRate}}</td>
          <td class="text-center">
            {{item.receivableAmount}}/{{item.amount}}{{$t('printPayFee.yuan')}}
            <span v-if="item.amount < 0">({{ $t('printPayFee.refund') }})</span>
          </td>
          <td class="text-center">{{item.discountPrice || 0}}</td>
          <td class="text-center">{{item.remark}}</td>
        </tr>
        <tr>
          <td colspan="3" class="text-center">{{ $t('printPayFee.capitalRMB') }}</td>
          <td colspan="2" class="text-center">{{changeNumMoneyToChinese(printPayFeeInfo.amount)}}</td>
          <td colspan="1" class="text-center">{{printPayFeeInfo.amount}}</td>
          <td colspan="2" class="text-center">{{ $t('printPayFee.accountDeduction') }}</td>
          <td colspan="2" class="text-center receipt-summary-stamp-cell">
            {{printPayFeeInfo.acctAmount}}
            <img class="invoice-image" src="/img/invoice_img.png">
          </td>
        </tr>
        <tr v-if="printPayFeeInfo.content || printPayFeeInfo.qrImg">
          <td colspan="6">
            <div style="max-width: 600px;" v-html="printPayFeeInfo.content"></div>
          </td>
          <td colspan="4">
            <img v-if="printPayFeeInfo.qrImg" :src="printPayFeeInfo.qrImg" width="100px" height="100px">
          </td>
        </tr>
      </tbody>
    </table>

    <div class="signature-row">
      <div>{{ $t('printPayFee.operator') }}</div>
      <div class="customer-confirm-signature">{{ $t('printPayFee.customerConfirm') }}</div>
    </div>

      </div>
    </div>

    <div id="print-btn" class="print-actions">
      <el-button type="primary" @click="handlePrint">
        <i class="el-icon-printer"></i>&nbsp;{{ $t('common.print') }}
      </el-button>
      <el-button type="warning" @click="handleClose">
        {{ $t('common.cancel') }}
      </el-button>
    </div>
  </div>
</template>

<script>
import { getCommunityId, getCommunityName } from '@/api/community/communityApi'
import { queryFeeReceipt, queryFeeReceiptDetail, queryFeePrintSpec } from '@/api/fee/printPayFeeApi'
import { getUserId, getUserName } from '@/api/user/userApi'
import { dateFormat } from '@/utils/dateUtil'
import { changeNumMoneyToChinese } from '@/utils/moneyUtil' 

export default {
  name: 'PrintPayFeeList',
  data() {
    return {
      printPayFeeInfo: {
        communityName: '',
        receiptId: '',
        receiptIds: '',
        detailIds: '',
        roomName: '',
        amount: 0.00,
        fees: [],
        feeTime: '',
        wechatName: '',
        content: '',
        qrImg: '',
        payObjName: '',
        feeReceipt: [],
        apply: 'N',
        receiptNum: '',
        acctAmount: 0
      },
      userInfo: {},
      printFlag: '0',
      communityId: ''
    }
  },
  created() {
    this.communityId = getCommunityId()
    this.userInfo = {
      userId: getUserId(),
      name: getUserName()
    }
    this.initData()
  },
  methods: {
    initData() {
      this.printPayFeeInfo.receiptId = this.$route.query.receiptId
      this.printPayFeeInfo.receiptIds = this.$route.query.receiptIds
      this.printPayFeeInfo.detailIds = this.$route.query.detailIds
      if(this.$route.query.apply){
        this.printPayFeeInfo.apply = this.$route.query.apply
      }
      this.printPayFeeInfo.merge = this.$route.query.merge
      this.printPayFeeInfo.communityName =  getCommunityName()

      this.loadReceipt()
      this.loadPrintSpec()
    },
    loadReceipt() {
      const params = {
        page: 1,
        row: 30,
        receiptId: this.printPayFeeInfo.receiptId,
        receiptIds: this.printPayFeeInfo.receiptIds,
        detailIds: this.printPayFeeInfo.detailIds,
        communityId: this.communityId
      }

      queryFeeReceipt(params).then(response => {
        const feeReceipt = response.data
        let amount = 0
        feeReceipt.forEach(item => {
          amount += parseFloat(item.amount)
        })

        this.printPayFeeInfo.amount = amount.toFixed(2)
        this.printPayFeeInfo.roomName = feeReceipt[0].objName
        this.printPayFeeInfo.feeTime = feeReceipt[0].createTime
        this.printPayFeeInfo.payObjName = feeReceipt[0].payObjName
        this.printPayFeeInfo.feeReceipt = feeReceipt
        this.printPayFeeInfo.receiptNum = feeReceipt[0].receiptCode

        this.loadReceiptDetail()
      })
    },
    loadReceiptDetail() {
      const params = {
        page: 1,
        row: 100,
        receiptId: this.printPayFeeInfo.receiptId,
        receiptIds: this.printPayFeeInfo.receiptIds,
        detailIds: this.printPayFeeInfo.detailIds,
        communityId: this.communityId,
        mergeFee: this.printPayFeeInfo.merge
      }

      queryFeeReceiptDetail(params).then(response => {
        const feeReceiptDetails = response.data
        this.printPayFeeInfo.receiptNum = this.printPayFeeInfo.receiptNum + "(" + feeReceiptDetails[0].payOrderId + ")"
        if (feeReceiptDetails[0].amount < 0) {
          this.printPayFeeInfo.apply = 'R'
        }
        let acctAmount = 0.0
        feeReceiptDetails.forEach(item => {
          acctAmount = acctAmount + parseFloat(item.acctAmount)
          this.printPayFeeInfo.feeReceipt.forEach(im => {
            if (item.receiptId == im.receiptId) {
              item.objName = im.objName
              item.feeTypeCd = im.feeTypeCd
            }
          })
        })
        this.printPayFeeInfo.fees = feeReceiptDetails
        this.printPayFeeInfo.acctAmount = acctAmount.toFixed(2)
      })
    },
    loadPrintSpec() {
      const params = {
        page: 1,
        row: 1,
        specCd: 2020,
        communityId: this.communityId
      }

      queryFeePrintSpec(params).then(response => {
        const data = response.data
        if (data.length > 0) {
          this.printPayFeeInfo.content = data[0].content
          this.printPayFeeInfo.qrImg = data[0].qrImg
          if (data[0].printName) {
            this.printPayFeeInfo.communityName = data[0].printName
          }
        }
      })
    },
    dateFormat(date) {
      if (!date) return ''
      return dateFormat(date)
    },
    changeNumMoneyToChinese,
    handlePrint() {
      this.printFlag = '1'
      document.getElementById("print-btn").style.display = "none"
      window.print()
      window.close()
    },
    handleClose() {
      window.close()
    }
  }
}
</script>

<style scoped>
.print-pay-fee-container {
  padding: 10px;
}

.receipt-page {
  width: 210mm;
  min-height: 297mm;
  margin: 0 auto;
  box-sizing: border-box;
}

.receipt-copy {
  position: relative;
  min-height: 140mm;
  padding: 8mm 6mm;
  box-sizing: border-box;
  page-break-inside: avoid;
}

.receipt-copy + .receipt-copy {
  border-top: 1px dashed #999;
}

.receipt-title {
  color: #000;
  font-size: 22px;
  line-height: 1.3;
  margin-bottom: 4px;
}

.float-left {
  float: left;
}

.float-right {
  float: right;
}

.text-center {
  text-align: center;
}

.text-right {
  text-align: right;
}

.receipt-info-row {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: end;
  column-gap: 12px;
  min-height: 38px;
  color: #000;
  font-size: 14px;
}

.receipt-table-align {
  width: 100%;
  margin-left: 0;
  box-sizing: border-box;
}

.receipt-owner {
  justify-self: start;
  text-align: left;
  padding-left: 0;
}

.receipt-info-row .float-left,
.receipt-info-row .float-right {
  float: none;
}

.receipt-table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  color: #000;
  font-size: 13px;
  line-height: 1.25;
}

.receipt-table th,
.receipt-table td {
  padding: 3px 2px;
  word-break: break-all;
  vertical-align: middle;
}

.receipt-table tbody {
  font-size: 13px;
}

.col-index {
  width: 5%;
}

.col-fee-name {
  width: 12%;
}

.col-obj-name {
  width: 10%;
}

.col-fee-range {
  width: 18%;
}

.col-unit-price {
  width: 9%;
}

.col-area {
  width: 9%;
}

.col-pay-method {
  width: 9%;
}

.col-amount {
  width: 12%;
}

.col-discount {
  width: 7%;
}

.col-remark {
  width: 9%;
}

.receipt-invoice-tip {
  text-align: center;
  white-space: nowrap;
}

.signature-row {
  display: flex;
  justify-content: space-between;
  color: #000;
  font-size: 18px;
  margin: 0 140px 20px 0;
}

.customer-confirm-signature {
  min-width: 220px;
  text-align: left;
}

.receipt-summary-stamp-cell {
  position: relative;
}

.invoice-image {
  position: absolute;
  right: 23mm;
  bottom: -20mm;
  width: 240px;
  max-height: 120px;
  object-fit: contain;
  transform: translateY(12px);
}

.print-actions {
  position: fixed;
  right: 24px;
  top: 50%;
  z-index: 999;
  display: flex;
  flex-direction: column;
  gap: 12px;
  transform: translateY(-50%);
}

.print-actions .el-button + .el-button {
  margin-left: 0;
}

.el-row {
  width: 100%;
  margin-bottom: 20px;
}

.el-col {
  width: 100%;
}

@media print {
  @page {
    size: A4 portrait;
    margin: 0;
  }

  .print-pay-fee-container {
    padding: 0;
  }

  .receipt-page {
    width: 210mm;
    min-height: 297mm;
  }
}
</style>